import React, { useEffect, useState } from 'react'
import { constants } from '../../constants'
import { connect } from 'react-redux'
import {
  fetchHealthCoachList,
  updateActionCase,
} from '../../store/action/actioncases.action'
import util from '../../util/util'
import {
  Layout,
  Button,
  Input,
  Select,
  Typography,
  Breadcrumb,
  message,
  Row,
  Modal,
  Col,
} from 'antd'
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import SessionStorage from '../../util/sessionstore'
import {
  getPatientsFourdigits,
  createNewCase,
} from '../../store/action/actioncases.action'
import WorkLog from './worklog'
import { PlusCircleFilled } from '@ant-design/icons'
import ApolloClientService from '../../services/apolloclient.service'
import { loginAsCustomer } from '../../store/action/profile.action'
import moment from 'moment'
import { fetchUsers } from '../../store/action/user.action'
import { upperFirst } from 'lodash'
const apolloClient = new ApolloClientService()
const { Content } = Layout
const { TextArea } = Input
const { Option } = Select
const { Text } = Typography

const session = new SessionStorage()

const _title = [
  {
    value: constants.ACTION_CASE_TITLE.NEW_DEVICE_ORDER,
    label: 'New Device Order',
  },
  {
    value: constants.ACTION_CASE_TITLE.NEW_PATIENT,
    label: 'New Patient',
  },
  {
    value: constants.ACTION_CASE_TITLE.PATIENT_TECHNICAL,
    label: 'Patient Technical',
  },
  {
    value: constants.ACTION_CASE_TITLE.SYSTEM_TECHNICAL,
    label: 'System Technical',
  },
]

const _status = [
  {
    value: constants.ACTION_CASE_STATUS.UNASSIGNED,
    label: 'Unassigned',
  },
  {
    value: constants.ACTION_CASE_STATUS.ASSIGNED,
    label: 'Assigned',
  },
  {
    value: constants.ACTION_CASE_STATUS.RESOLVED,
    label: 'Resolved',
  },
  {
    value: constants.ACTION_CASE_STATUS.UNRESOLVED,
    label: 'Unresolved',
  },
  {
    value: constants.ACTION_CASE_STATUS.NOTANISSUE,
    label: 'Not an Issue',
  },
]

const _priority = [
  {
    value: constants.ACTION_CASE_PRIORITY.ONE,
    label: 'P1',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.TWO,
    label: 'P2',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.THREE,
    label: 'P3',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.FOUR,
    label: 'P4',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.CRITICAL,
    label: 'Critical',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.BLOCKER,
    label: 'Blocker',
  },
]

function CreateActionCase(props) {
  var location = useLocation()

  const [healthCoachList, setHealthCoachList] = useState([])
  const [lastLoggedTime, setLastLoggedTime] = useState(null)
  var history = useHistory()
  console.log('HIF', history.location)
  const profile = session.getProfile()

  const currentUserId = profile?.user?._id
  const currentUserCompanyId = profile.company?._id

  useEffect(() => {
    // props.getPatientsFourdigits();
    // props.getHealthCoachList({ companyid: currentUserCompanyId });
    props.fetchUsers({
      companyid: props.company?._id,
      pagination: { current: null, pageSize: null },
      searchText: props.searchText,
      sorter: { order: 'ascend', field: 'surgery' },
      active: true,
    })
    fetchCustomerList(props?.company?._id)
  }, [])

  useEffect(() => {
    const userList =
      // props.healthCoachList?
      props.users.map((user) => ({
        id: user._id,
        name: user.firstname + ' ' + user.lastname,
      }))
    setHealthCoachList(userList)
  }, [props.users])

  const [caseInputs, setCaseInputs] = useState({
    patientId:history.location.state?.patientid || null,
    status: history.location.state?.HCid ? constants.ACTION_CASE_STATUS.ASSIGNED : null,
    priority: null,
    assignedTo: history.location.state?.HCid
      ? history.location.state?.HCid
      : null,
    summary: null,
    description: null,
    type: history.location.state?.type || null,
    lastFourDigits: history.location.state?.lastFourDigits || null,
    date: null,
    hrs: null,
    mins: null,
    workDescription: null,
    createdAt: null,
    customerId:
      history.location.state?.customer?.key ||
      history.location.state?.customer?._id ||
      null,
  })

  const [caseModal, setCaseModal] = useState(false)
  const [customerList, setCustomerList] = useState([])
  const [isLoading, setIsLoading] = useState({
    healthCoachList: false,
    customerList: false,
  })

  const showCaseModal = () => {
    setCaseModal((prev) => !prev)
  }

  const isValidInput = () => {
    const {
      status,
      priority,
      assignedTo,
      type,
      description,
      summary,
      customerId,
    } = caseInputs

    const r =
      customerId &&
      customerId.trim() !== '' &&
      status &&
      status.trim() !== '' &&
      priority &&
      priority.trim() !== '' &&
      ((assignedTo && assignedTo.trim() !== '') || status == 'Unassigned') &&
      type &&
      type.trim() !== '' &&
      description &&
      description.trim() !== '' &&
      summary &&
      summary.trim() !== ''
    console.log(r, caseInputs)
    return r
  }

  const savetimeTracking = (tstring, timeTrackingData) => {
    const combineInputs = { ...caseInputs, ...timeTrackingData }
    console.log(timeTrackingData, 'caseInputs1')
    setLastLoggedTime({ tstring, ...timeTrackingData })
    setCaseInputs(combineInputs)
    // handleSaveClick(combineInputs);
  }

  async function fetchCustomerList(companyId, healthCoachId) {
    try {
      setIsLoading((prev) => ({ ...prev, customerList: true }))

      const customerList = await apolloClient.getCustomersIdAndNameList({
        companyId: companyId,
        healthCoachId: healthCoachId ?? '',
      })

      if (customerList.status == constants.MESSAGE.SUCCESS) {
        const userList = customerList?.customers?.map((customer) => ({
          value: customer.id,
          label: customer.name,
        }))
        setCustomerList(userList)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading((prev) => ({ ...prev, customerList: false }))
    }
  }

  async function handleBackClick() {
    if (history.location.state?.back.includes('/patient/'))
      props.loginAsCustomer({ ...history.location.state?.customer })
    history.push({ pathname: history.location?.state?.back || '/cases' })
  }

  function handleCancelClick() {
    setCaseInputs({
      title: '',
      status: '',
      priority: '',
      assignedTo: '',
      summary: '',
      description: '',
      customerId: '',
    })
    if (history.location.state?.back.includes('/patient/'))
      props.loginAsCustomer(history.location.state?.customer)
    history.push({ pathname: history.location.state?.back || '/cases' })
  }

  async function handleSaveClick() {
    console.log('caseInputs ---------------->>>', caseInputs)
    if (!isValidInput()) return
    var res = await props.createNewCase(caseInputs)
    if ((res.status = constants.MESSAGE.SUCCESS)) {
      history.push('/cases')
      message.success('Case created')
    } else message.error('Something went wrong!')
  }

  return (
    <div>
      <div className='card2'>
        <Breadcrumb style={{ marginBottom: '2vh' }}>
          {/* {location.state?.home && (
            <Breadcrumb.Item>
              <Link to="/home">Home</Link>
            </Breadcrumb.Item>
          )} */}
          <Breadcrumb.Item>
            <Link to='/patient'>Cases</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Add</Breadcrumb.Item>
        </Breadcrumb>
        <div className='general-detail-container'>
          <h2>Create New Case</h2>
          <Button className='back-button' onClick={handleBackClick}>
            Back
          </Button>
        </div>
        <div className='general-details2'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '40%',
              gap: '2vh',
            }}
          >
            <Row className='field2'>
              <Text
                style={{
                  fontWeight: 'normal',
                  width: '30%',
                  paddingRight: '0%',
                  textAlign: 'left',
                }}
              >
                Clinic Name :{' '}
              </Text>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children[1]
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder='Select  Clinic Name'
                value={
                  caseInputs?.title ||
                  history.location.state?.customer?.key ||
                  history.location.state?.customer?._id
                }
                disabled={history.location.state?.customer}
                style={{ width: '70%' }}
                onChange={(value) =>
                  setCaseInputs({ ...caseInputs, customerId: value })
                }
              >
                {customerList.map((customer) => {
                  return (
                    <Option value={customer.value}> {customer.label}</Option>
                  )
                })}
              </Select>
            </Row>

            <div className='field2'>
              <Text
                style={{
                  fontWeight: 'normal',
                  width: '30%',
                  paddingRight: '0%',
                  textAlign: 'left',
                }}
              >
                Type : <Text className='required-input-color'>*</Text>
              </Text>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children[1]
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder='Select  type'
                value={caseInputs.title || history.location.state?.type}
                disabled={history.location.state?.type}
                style={{ width: '70%' }}
                required={true}
                onChange={(value) =>
                  setCaseInputs({ ...caseInputs, title: value })
                }
              >
                {_title.map((item) => {
                  return <Option value={item.value}> {item.label}</Option>
                })}
              </Select>
            </div>
            {history.location.state?.type == 'Patient Technical' && (
              <div className='field2'>
                <Text
                  style={{
                    fontWeight: 'normal',
                    width: '30%',
                    paddingRight: '0%',
                    textAlign: 'left',
                  }}
                >
                  Patient name:
                </Text>
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children[1]
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder='Select last 4 digit of patient phone number'
                  value={
                    upperFirst(history.location.state?.firstname) +
                    ' ' +
                    upperFirst(history.location.state?.lastname)
                  }
                  disabled
                  suffixIcon={null}
                  style={{ width: '70%' }}
                ></Select>
              </div>
            )}
            {history.location.state?.type == 'Patient Technical' && (
              <div className='field2'>
                <Text
                  style={{
                    fontWeight: 'normal',
                    width: '30%',
                    paddingRight: '0%',
                    textAlign: 'left',
                  }}
                >
                  Patient phone:
                </Text>
                <Select
                  showSearch
                  suffixIcon={null}
                  filterOption={(input, option) =>
                    option.children[1]
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder='Select last 4 digit of patient phone number'
                  value={
                    caseInputs.title ||
                    'XXXXX-X' + (history.location.state?.lastFourDigits || '')
                  }
                  
                  disabled
                  style={{ width: '70%'}}
                  onChange={(value) =>
                    setCaseInputs({ ...caseInputs, title: value })
                  }
                ></Select>
              </div>
            )}

            <div className='field2'>
              <Text
                style={{
                  fontWeight: 'normal',
                  width: '30%',
                  paddingRight: '0%',
                  textAlign: 'left',
                }}
              >
                Priority : <Text className='required-input-color'>*</Text>
              </Text>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children[1]
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder='Select  priority'
                value={caseInputs.priority}
                style={{ width: '70%' }}
                onChange={(value) =>
                  setCaseInputs({ ...caseInputs, priority: value })
                }
                required={true}
              >
                {_priority.map((item) => {
                  return <Option value={item.value}> {item.label}</Option>
                })}
              </Select>
            </div>

            <div className='field2'>
              <Text
                style={{
                  fontWeight: 'normal',
                  width: '30%',
                  paddingRight: '0%',
                  textAlign: 'left',
                }}
              >
                Status : <Text className='required-input-color'>*</Text>
              </Text>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children[1]
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder='Select  status'
                value={caseInputs.status}
                style={{ width: '70%' }}
                required={true}                
                onChange={(value) => {
                  if (value == 'Unassigned') {
                    setCaseInputs({
                      ...caseInputs,
                      status: value,
                      assignedTo: '',
                    })
                  } else {
                    setCaseInputs({ ...caseInputs, status: value })
                  }
                }}
              >
                {_status.map((item) => {
                  if (
                    item.label == 'Unassigned' &&
                    history.location.state?.HCid
                  )
                    return null
                  return <Option value={item.value}> {item.label}</Option>
                })}
              </Select>
            </div>

            <div className='field2'>
              <Text
                style={{
                  fontWeight: 'normal',
                  width: '30%',
                  paddingRight: '0%',
                  textAlign: 'left',
                }}
              >
                Assigned to : <Text className='required-input-color'>*</Text>
              </Text>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children[1]
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder='Select assignee'
                value={caseInputs.assignedTo}
                style={{ width: '70%' }}
                // disabled={caseInputs.status == "Unassigned"|| history.location.state?.HCid}
                disabled={caseInputs.status == "Unassigned" || history.location.state?.HCid}
                onChange={(value) =>
                  setCaseInputs({ ...caseInputs, assignedTo: value })
                }
                required={true}
              >
                {healthCoachList
                  ?.sort((a, b) => a.name.localeCompare(b.name))
                  .map((item) => {
                    return <Option value={item.id}> {item.name}</Option>
                  })}
              </Select>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '60%',
              gap: '2vh',
            }}
          >
            <div className='field2'>
              <Text
                style={{
                  fontWeight: 'normal',
                  width: '25%',
                  textAlign: 'left',
                }}
              >
                Subject : <Text className='required-input-color'>*</Text>
              </Text>
              <TextArea
                placeholder='Enter subject'
                style={{ minHeight: '6vh' }}
                value={caseInputs.summary}
                required={true}
                onChange={(e) =>
                  setCaseInputs({
                    ...caseInputs,
                    summary: e.target.value,
                  })
                }
              />
            </div>
            <div className='field2'>
              <Text
                style={{
                  fontWeight: 'normal',
                  width: '25%',
                  textAlign: 'left',
                }}
              >
                Description : <Text className='required-input-color'>*</Text>
              </Text>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                }}
              >
                <TextArea
                  style={{ minHeight: '22vh' }}
                  value={caseInputs.description}
                  placeholder='Enter description'
                  required={true}
                  onChange={(e) =>
                    setCaseInputs({
                      ...caseInputs,
                      description: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className='field2'>
              <Text
                style={{
                  fontWeight: 'normal',
                  width: '30%',
                  paddingRight: '0%',
                  textAlign: 'left',
                }}
              >
                Work Log:
                {lastLoggedTime && (
                  <Text>
                    &nbsp;{' '}
                    {(lastLoggedTime?.createdAt).format('MM-DD-YYYY') +
                      ' ' +
                      lastLoggedTime.tstring?.hours +
                      'h ' +
                      lastLoggedTime.tstring?.minutes +
                      'm'}
                    &nbsp;
                  </Text>
                )}
                <PlusCircleFilled
                  onClick={showCaseModal}
                  className='pluscirclefilled'
                />
              </Text>
              {caseModal && (
                <Modal
                  visible={caseModal}
                  footer={false}
                  onCancel={() => showCaseModal()}
                >
                  <Row>
                    <WorkLog
                      savetimeTracking={savetimeTracking}
                      actionCase={''}
                      showCaseModal={showCaseModal}
                    />
                  </Row>
                </Modal>
              )}
            </div>
          </div>
        </div>

        <div
          className='buttons'
          style={{
            flexDirection: 'row',
            gap: '2rem',
            paddingRight: '20px',
            justifyContent: 'end',
            marginLeft: 'auto',
            width: '100%',
          }}
        >
          <Button
            type='default'
            style={{ width: '10rem' }}
            onClick={handleCancelClick}
          >
            Cancel
          </Button>
          <Button
            style={{
              width: '10rem',
              backgroundColor: '#001529',
              color: 'white',
            }}
            onClick={handleSaveClick}
            disabled={!isValidInput()}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  console.log('state ---------------->>>', state)

  return {
    isLoading: state.actioncase.isLoading,
    healthCoachList: state.actioncase.healthCoachList,
    token: util.verifyToken(state.profile.token),
    customer: state.profile.customer,
    patientlist: state.actioncase.patientlist,
    company: state.profile.company,
    searchText: state.user.searchText,
    users: state.user.users,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateActionCase: (params) => {
      return dispatch(updateActionCase(params))
    },

    getHealthCoachList: (params) => {
      return dispatch(fetchHealthCoachList(params))
    },
    getPatientsFourdigits: () => dispatch(getPatientsFourdigits()),
    createNewCase: (input) => dispatch(createNewCase(input)),
    loginAsCustomer: (params) => dispatch(loginAsCustomer(params)),
    fetchUsers: (params) => dispatch(fetchUsers(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateActionCase)
